import { dateToLocalFormat } from 'helpers/dateToLocalFormat';
import BackButton from 'common/BackButton/BackButton';
import ErrorState from 'common/ErrorState/ErrorState';
import { getArticleFetch } from 'api/content';
import NotFound from '../../NotFound/NotFound';
import { useParams } from 'react-router-dom';
import { useRecord } from 'hooks/useRecord';
import Loader from 'components/Loader/Loader';
import './NewsInfo.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Сторінка новини — ADR-0005.
 *
 * Прибрано: window.scrollTo(0, 0) прямо в JSX (побічний ефект під час рендеру,
 * тепер це робить ScrollToTop у App) і накладка з піктограмою «розгорнути», яка
 * нічого не відкривала — фальшива підказка інтерактивності.
 *
 * Новину сторінка питає окремим запитом. Раніше вона шукала її у вже
 * завантаженому списку, тому при збої запиту список лишався порожнім і
 * сторінка назавжди зависала на лоадері.
 */
export default function NewsInfo() {
  const language = useLanguage();
  const apiBase = process.env.REACT_APP_BASE_API_URL || '';
  const { articleId } = useParams();

  const { data: article, status, error, retry } = useRecord(getArticleFetch, articleId);

  if (status === 'loading') return <Loader />;

  if (error?.kind === 'notFound') return <NotFound />;

  if (status === 'failed') {
    return (
      <div className='container section'>
        <ErrorState error={error} onRetry={retry} variant='page' />
      </div>
    );
  }

  if (!article) return <NotFound />;
  if (article.type !== 'Новина' && article.type !== 'Анонс') return <NotFound />;

  const gallery = article.media || [];
  const cover = article.front?.url;

  return (
    <article className='article-info section'>
      <div className='container'>
        <BackButton />

        <header className='article-head'>
          <time className='article-date tnum'>{dateToLocalFormat(article?.publicationDate || article.createdAt)}</time>
          <h1 className='article-title'>{article.title}</h1>
        </header>

        <div className='article-wrapper'>
          <div className='article-text-wrapper'>
            <p className='article-description'>
              {article.description}
            </p>
          </div>

          <div className={`article-img-wrapper ${gallery.length === 0 ? 'single' : ''}`}>
            {cover && (
              <figure className='box'>
                <img
                  src={apiBase + cover}
                  alt={language === 'en' ? 'The main photo of the news' : 'Головна фотографія новини'}
                />
              </figure>
            )}
            {gallery.map((photo) => (
              <figure className='box' key={photo.id}>
                <img
                  src={apiBase + photo.url}
                  alt={language === 'en' ? 'News photo' : 'Фотографія новини'}
                  loading='lazy'
                />
              </figure>
            ))}
          </div>
        </div>
      </div>
    </article>
  );
}
